import CircleIcon from '@mui/icons-material/Circle';
import { Typography, Box, Tooltip } from '@mui/material';

const TrafficLightIndicator = ({ value, lowThreshold, highThreshold }) => {
  let color = 'grey';
  
  if (value < lowThreshold*0.9 | value > highThreshold*1.1 ) {
    color = 'traffic.red';
    
  } else if (value >= lowThreshold && value <= highThreshold) {
    color = 'traffic.green';
   
  } else if (value > highThreshold*1.1 | value < lowThreshold*0.9) {
    color = 'traffic.orange';
   
  }

   return (
   
      <Box display="flex" alignItems="center" sx={{ cursor: 'pointer' }}>
        <CircleIcon sx={{ color, fontSize: 20, mr: 1 }} />
      </Box>
  
  );
};

export default TrafficLightIndicator;